export default __webpack_public_path__ + "static/media/IResponsiveCAFullSize.f72aee7b.png";